import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-sidebar',
  templateUrl: './account-sidebar.component.html',
  styleUrls: ['./account-sidebar.component.css']
})
export class AccountSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
